export type FeatureRow = {
  name: string
  tooltipTitle: string
  tooltipText: string
  availability: boolean[]
}

export const featureRows: FeatureRow[] = [
  {
    name: 'plans.featureRows.cameraRawPhotoCalibration.name',
    tooltipTitle: 'plans.featureRows.cameraRawPhotoCalibration.tooltipTitle',
    tooltipText: 'plans.featureRows.cameraRawPhotoCalibration.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.myProjects.name',
    tooltipTitle: 'plans.featureRows.myProjects.tooltipTitle',
    tooltipText: 'plans.featureRows.myProjects.tooltipText',
    availability: [true, true, true, true],
  },
  {
    name: 'plans.featureRows.matisseLite.name',
    tooltipTitle: 'plans.featureRows.matisseLite.tooltipTitle',
    tooltipText: 'plans.featureRows.matisseLite.tooltipText',
    availability: [false, false, true, true],
  },
  {
    name: 'plans.featureRows.shadeGuideAi.name',
    tooltipTitle: 'plans.featureRows.shadeGuideAi.tooltipTitle',
    tooltipText: 'plans.featureRows.shadeGuideAi.tooltipText',
    availability: [true, true, true, true],
  },
  {
    name: 'plans.featureRows.allInOneRecipe.name',
    tooltipTitle: 'plans.featureRows.allInOneRecipe.tooltipTitle',
    tooltipText: 'plans.featureRows.allInOneRecipe.tooltipText',
    availability: [false, false, true, true],
  },
  {
    name: 'plans.featureRows.aestheticModel.name',
    tooltipTitle: 'plans.featureRows.aestheticModel.tooltipTitle',
    tooltipText: 'plans.featureRows.aestheticModel.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.frameworkAdvice.name',
    tooltipTitle: 'plans.featureRows.frameworkAdvice.tooltipTitle',
    tooltipText: 'plans.featureRows.frameworkAdvice.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.frameworkStaining.name',
    tooltipTitle: 'plans.featureRows.frameworkStaining.tooltipTitle',
    tooltipText: 'plans.featureRows.frameworkStaining.tooltipText',
    availability: [false, false, true, true],
  },
  {
    name: 'plans.featureRows.opaquerRecipes.name',
    tooltipTitle: 'plans.featureRows.opaquerRecipes.tooltipTitle',
    tooltipText: 'plans.featureRows.opaquerRecipes.tooltipText',
    availability: [false, false, true, true],
  },
  {
    name: 'plans.featureRows.dentinRecipes.name',
    tooltipTitle: 'plans.featureRows.dentinRecipes.tooltipTitle',
    tooltipText: 'plans.featureRows.dentinRecipes.tooltipText',
    availability: [false, false, true, true],
  },
  {
    name: 'plans.featureRows.skinEnamelRecipes.name',
    tooltipTitle: 'plans.featureRows.skinEnamelRecipes.tooltipTitle',
    tooltipText: 'plans.featureRows.skinEnamelRecipes.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.internalEffects.name',
    tooltipTitle: 'plans.featureRows.internalEffects.tooltipTitle',
    tooltipText: 'plans.featureRows.internalEffects.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.stainingStudio.name',
    tooltipTitle: 'plans.featureRows.stainingStudio.tooltipTitle',
    tooltipText: 'plans.featureRows.stainingStudio.tooltipText',
    availability: [false, true, true, true],
  },
  {
    name: 'plans.featureRows.ceramicStudio.name',
    tooltipTitle: 'plans.featureRows.ceramicStudio.tooltipTitle',
    tooltipText: 'plans.featureRows.ceramicStudio.tooltipText',
    availability: [true, true, true, true],
  },
  {
    name: 'plans.featureRows.dehazing.name',
    tooltipTitle: 'plans.featureRows.dehazing.tooltipTitle',
    tooltipText: 'plans.featureRows.dehazing.tooltipText',
    availability: [true, true, true, true],
  },
  {
    name: 'plans.featureRows.colorChecker.name',
    tooltipTitle: 'plans.featureRows.colorChecker.tooltipTitle',
    tooltipText: 'plans.featureRows.colorChecker.tooltipText',
    availability: [true, true, true, true],
  },
  {
    name: 'plans.featureRows.gingiva.name',
    tooltipTitle: 'plans.featureRows.gingiva.tooltipTitle',
    tooltipText: 'plans.featureRows.gingiva.tooltipText',
    availability: [false, false, false, true],
  },
  {
    name: 'plans.featureRows.freeMobileApp.name',
    tooltipTitle: 'plans.featureRows.freeMobileApp.tooltipTitle',
    tooltipText: 'plans.featureRows.freeMobileApp.tooltipText',
    availability: [true, true, true, true],
  },
]
